import BaseService from './Base';
import ConfigService from './Config';

class CustomConfigService extends BaseService {
  static endpoint = 'api/2.0/custom-configs/';

  static async getByAccount(account) {
    const url = ConfigService.generateURL(this.endpoint, {'account_id': account});
    try {
      const response = await window.fetch(url, {
        method: 'GET',
        headers: {
            Authorization: 'jwt ' + localStorage.getItem('jwt_token'),
            'Time-Zone': jstz.determine().name()
        }
      });
      const JSONresponse = await response.json();
      if (response.ok) {
        return JSONresponse;
      } else {
        return null;
      }
    } catch (e) {
      return null;
    }
  }
}

export default CustomConfigService;